import { LoyaltyLevel } from 'models/loyalty';
import React from 'react';

interface LoyaltyCardProps {
    size?: string;
    type?: string;
    largeInfoTitle?: string;
    largeInfoDescription?: string;
    largeSuccessTitle?: string;
    largeSuccessDescription?: string;
    largeInfoDescriptionSuccess?: string;
    smallAlertDescription?: string;
    smallInfoTitle?: string;
    smallSuccessTitle?: string;
    expiredSum?: number;
    expirationDate?: string;
    collectedSum?: number;
    freeSum?: string | number; 
    maxSum?: number;
    isPrivilegedGroup?: boolean;
    levelId?: string;
    loyaltyLevels?: LoyaltyLevel[];
    fuelCapacity?: number;
    fuelDiscount?: number;
    currentDiscount?: number;
    className?: string;
}

const FUEL_FULL_LITRES = 100;

export function LoyaltyCard(props: LoyaltyCardProps) {

    let fuelHeight = Number(props.fuelCapacity);
    if (fuelHeight > FUEL_FULL_LITRES) {
        fuelHeight = FUEL_FULL_LITRES;
    } else if (fuelHeight < 20) {
        fuelHeight = 24;
    } else if (fuelHeight < 55) {
        fuelHeight = 1.2 * fuelHeight;
    }

    const largeSuccessTitle = getLargeSuccessTitle(props);
    const largeInfoDescription = getLargeInfoDescription(props);
    const largeSuccessDescription = getLargeSuccessDescription(props);
    const level2Discount = props.fuelDiscount;
    const fuelCapacity = props.fuelCapacity || 0;

    const LoyaltyCardLarge = (
        <div className="loyalty-card__container loyalty-card__container-large">
            <div className={"loyalty-card__info" + ((!props.isPrivilegedGroup && fuelCapacity >= FUEL_FULL_LITRES) ? ' loyalty-card__info--success' : '')}>
                <div>
                    <i className={`info__icon-large icon__fuel ${ fuelHeight === FUEL_FULL_LITRES ? "" : "mr-4" } `}>
                        {   fuelHeight < FUEL_FULL_LITRES &&
                            <i className="icon__fuel-amount" style={{ height: 'calc(78px*' + fuelCapacity + '/' + FUEL_FULL_LITRES + ')' }}>{fuelCapacity.toFixed(1)} L</i>
                        }
                            <span className="info__icon-fuel" style={{ height: fuelHeight }}></span>
                    </i>
                </div>
                <div>
                    <p>
                        <span dangerouslySetInnerHTML={{ __html: largeInfoDescription || '' }}></span>
                        {!props.isPrivilegedGroup && fuelCapacity < FUEL_FULL_LITRES && <strong>{level2Discount?.toFixed(1)}s/L</strong>}
                    </p>
                </div>
            </div>
        { (!props.isPrivilegedGroup && fuelCapacity >= FUEL_FULL_LITRES) && <div className="loyalty-card__success px-sm-4">
                <p>{largeSuccessTitle}</p>
                <span className="success__description--large">{largeSuccessDescription} {!props.isPrivilegedGroup && <span className="tag tag--success">{level2Discount?.toFixed(1)}s/L</span>}</span>
            </div>}
        </div>
    );

    const LoyaltyCardSmall = (
        <div className="loyalty-card__container">
            {
                props.smallAlertDescription &&
                <div className="loyalty-card__item loyalty-card__alert">
                    <p>{ props.smallAlertDescription }</p>
                </div>
            }
            <div className={"loyalty-card__info" + (!!props.smallSuccessTitle ? ' loyalty-card__info--success' : '')}>
                <div className="info__type">
                    <i className={"info__icon-small icon__" + props.type}></i>
                    {
                        props.maxSum != null &&
                        <span className={"info__progress info__title icon__circle-" + props.collectedSum + "-" + props.maxSum}></span>
                    }
                </div>
                {
                    props.maxSum != null &&
                    <p className="info__name">{props.smallInfoTitle}</p>
                }
            </div>
            {
                !!props.smallSuccessTitle &&
                <div className="loyalty-card__success">
                    <p><span dangerouslySetInnerHTML={{ __html: props.smallSuccessTitle || '' }}></span> {!!props.freeSum && <strong>{props.freeSum}</strong>}</p>
                </div>
            }
        </div>
    );

    return (
        <>
            {
                props.size === 'large' &&
                LoyaltyCardLarge
            }
            {
                props.size === 'small' &&
                LoyaltyCardSmall
            }
        </>
    );
}

const getLargeSuccessTitle = (props: any) => {
    return props.fuelCapacity + ' liitrit tangitud!';
}

const getLargeSuccessDescription = (props: any) => {
    return 'Järgmisel kuul rakendub sulle lisasoodustus';
}

const getLargeInfoDescription = (props: any) => {
    let text = '<strong>Sinu soodustus autokütustele</strong><br />';
    text += '<span class="d-inline-block bg-secondary-light text-dark rounded font-weight-bold p-2 my-1">' + (props.isPrivilegedGroup ? 'Erisoodus' : props.currentDiscount + ' s/L') +'</span><br />'
    if (props.fuelCapacity >= FUEL_FULL_LITRES) {
        text += '<strong>Suurepärane tankija!</strong><br/>';
    }

    if (props.isPrivilegedGroup || props.fuelCapacity >= FUEL_FULL_LITRES) {
        text += 'Oled sel kuul kokku tankinud <strong>' + (props.fuelCapacity ? props.fuelCapacity.toFixed(1) : 0) + '</strong> liitrit kütust.';
    } else {
        if (props.levelId === 'IDC') {
            text += 'Tangi veel vähemalt <strong>' + (FUEL_FULL_LITRES - props.fuelCapacity).toFixed(1) + '</strong> liitrit, et järgmisel kuul saada lisasoodustust';
        } else if (props.levelId === 'IDC2') {
            text += 'Tangi veel vähemalt <strong>' + (FUEL_FULL_LITRES - props.fuelCapacity).toFixed(1) + '</strong> liitrit, et järgmisel kuul säilitada lisasoodustus';
        }        
    }

    return text;
}
